module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"section.stat":"สถิติของ Ticket สำหรับ Drone รุ่นนี้","section.progress":"Ticket ที่อยู่ระหว่างดำเนินการ"}}')
  delete Component.options._Ctor
}
